import {theme as defaultTheme} from '@miro-site/design-tokens'

const theme = {
  background: {
    white: defaultTheme.colors.primaryWhite,
    dark: defaultTheme.colors.primaryIndigo,
    blue: defaultTheme.colors.lightBlue,
    pink: defaultTheme.colors.lightPink,
    yellow: defaultTheme.colors.lightYellow,
    'workshops-color-grey': defaultTheme.colors.workshopGray,
    'workshops-color-indigo': defaultTheme.colors.primaryIndigo,
    'workshops-color-blue': defaultTheme.colors.passionate,
    'workshops-color-pink': defaultTheme.colors.human,
    'workshops-color-red': defaultTheme.colors.bold,
    'workshops-color-yellow': defaultTheme.colors.outspoken,
  },
}

export default theme
